import { render, staticRenderFns } from "./GameStats.vue?vue&type=template&id=c26b3624&lang=pug&"
import script from "./GameStats.vue?vue&type=script&lang=js&"
export * from "./GameStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports